module.exports = __webpack_public_path__ + "img/6.762684b3.png";